import { useState, useEffect } from "react";
import { ShieldAlert } from "lucide-react";

var STORAGE_KEY = "rgp_age_verified";
var REJECT_REDIRECT_URL = "https://www.youtube.com/watch?v=_GOR5gvQwDI&list=RD_GOR5gvQwDI&start_radio=1";

export default function AgeGate() {
  var [visible, setVisible] = useState(false);

  useEffect(function () {
    try {
      var confirmed = sessionStorage.getItem(STORAGE_KEY) === "1";
      if (!confirmed) {
        setVisible(true);
        // Prevent background scroll while the gate is open
        document.body.style.overflow = "hidden";
      }
    } catch (e) {
      // sessionStorage may be unavailable in private mode — show the gate anyway
      setVisible(true);
      document.body.style.overflow = "hidden";
    }
    return function () {
      document.body.style.overflow = "";
    };
  }, []);

  function confirm() {
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (e) { /* ignore */ }
    document.body.style.overflow = "";
    setVisible(false);
  }

  function reject() {
    // Don't store anything — they should hit the gate again if they come back
    window.location.replace(REJECT_REDIRECT_URL);
  }

  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[9999] bg-black/95 backdrop-blur-sm flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-gate-title"
      data-testid="age-gate"
    >
      <div className="max-w-lg w-full bg-[#0a0a0a] border border-[#C0A062]/30 rounded-sm p-8 shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-sm bg-[#C0A062]/10 border border-[#C0A062]/40 flex items-center justify-center">
            <ShieldAlert className="w-6 h-6 text-[#C0A062]" />
          </div>
          <div>
            <p className="font-mono text-[#C0A062] text-[10px] uppercase tracking-widest">
              Restricted Access
            </p>
            <h2
              id="age-gate-title"
              className="font-heading font-black text-white text-2xl sm:text-3xl uppercase tracking-tight"
            >
              Age Verification
            </h2>
          </div>
        </div>

        <p className="text-[#D4D4D8] leading-relaxed mb-8">
          By entering this site, you confirm that you are at least 18 years of age and are
          legally permitted to purchase firearm-related products in your jurisdiction.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <button
            type="button"
            onClick={confirm}
            className="px-4 py-3 bg-[#C0A062] text-black font-mono uppercase text-xs tracking-wider rounded-sm hover:bg-[#d4b675] transition-colors"
            data-testid="age-gate-confirm"
            autoFocus
          >
            I confirm that I AM 18+
          </button>
          <button
            type="button"
            onClick={reject}
            className="px-4 py-3 bg-[#121212] text-[#A1A1AA] font-mono uppercase text-xs tracking-wider rounded-sm border border-white/10 hover:border-red-500/40 hover:text-red-300 transition-colors"
            data-testid="age-gate-reject"
          >
            I am NOT 18+
          </button>
        </div>

        <p className="text-center text-[#71717a] text-[10px] font-mono uppercase tracking-wider mt-6">
          Resurrected Gun Parts · Rebuild · Restore · Resurrect
        </p>
      </div>
    </div>
  );
}
